const houseCleaningLayers = [
    {
      id: 'VAH',
      src: '/animation_assets/housecleaning_VAH.png',
      width: '85px',
      height: '86px',
      left: '21.5%',
      top: '40%',
      zIndex: 29,
      role: 'primary',
      orientation: 'left',
      group: 0,
      alt: 'Icon of an upright vacuum cleaner',
    },
    {
      id: 'DMM',
      src: '/animation_assets/housecleaning_DMM.png',
      width: '16.6px',
      height: '16.6px',
      left: '23%',
      top: '45%',
      zIndex: 28, 
      alt: 'Blue diamond-shaped star icon', 
      role: 'secondary',
      group: 0,
    },
    {
      id: 'SIC',
      src: '/animation_assets/housecleaning_SIC.png',
      width: '14px',
      height: '14px',
      left: '26%',
      top: '38%',
      zIndex: 27, 
      alt: 'Blue four-point star shape',
      role: 'secondary',
      group: 0,
    },
    {
      id: 'MEC',
      src: '/animation_assets/housecleaning_MEC.png',
      width: '10px',
      height: '10px',
      left: '26.5%',
      top: '43%',
      zIndex: 26,
      alt: 'Blue diamond-shaped star graphic',
      role: 'secondary',
      group: 0,
    },
    {
      id: 'CEN',
      src: '/animation_assets/housecleaning_CEN.png',
      width: '278.6px',
      height: '20.7px',
      left: '23.4%',
      top: '61.7%',
      zIndex: 25,
      alt: 'HOUSE CLEANING SERVICES',
      role: 'text',
      group: 0
    },
    {
      id: 'HAH',
      src: '/animation_assets/housecleaning_HAH.png',
      width: '134px',
      height: '138px',
      left: '17%',
      top: '31.5%',
      zIndex: 24, 
      alt: 'Simple blue house shape icon',
      role: 'secondary',
      group: 1,
    },
    {
      id: 'RAZ',
      src: '/animation_assets/housecleaning_RAZ.png',
      width: '308px',
      height: '35.5px',
      left: '20%',
      top: '60%',
      zIndex: 22,
      alt: 'Blue horizontal rectangular line',
      role: 'secondary',
      group: 2,
    },
    {
      id: 'OCQ',
      src: '/animation_assets/housecleaning_OCQ.png',
      width: '144.6px',
      height: '219.0px',
      left: '53.1%',
      top: '25.9%',
      zIndex: 21,
      alt: 'C',
      role: 'text',
      group: 0
    },
    {
      id: 'BZQ',
      src: '/animation_assets/housecleaning_BZQ.png',
      width: '160.1px',
      height: '222.1px',
      left: '31.4%',
      top: '25.3%',
      zIndex: 20,
      alt: 'H',
      role: 'text',
      group: 0
    },
    {
      id: 'RBQ',
      src: '/animation_assets/housecleaning_RBQ.png',
      width: '513.0px',
      height: '513.0px',
      left: '0.0%',
      top: '-0.2%',
      zIndex: 19,
      alt: 'White background',
      role: 'background',
      group: 0
    }
  ];

  export default houseCleaningLayers;